export default __webpack_public_path__ + "static/media/backpack.625babf1.png";